/**
 * Footer
 * Site footer: brand blurb, quick links (Home / About / Contact), contact info
 * and the dynamic copyright line. Shows the app version pulled from package.json.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { version as appVersion } from '../../../package.json';
import { MASJID } from '../../config/masjid';
import Logo from '../../images/cole-harbour-islamic-society-logo.png';
import './style.css';

const Footer = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className={`wpo-ne-footer ${props.footerClass}`}>
      <footer className="wpo-site-footer">
        <div className="wpo-upper-footer">
          <div className="container">
            <div className="row">
              <div className="col col-lg-4 col-md-6 col-12">
                <div className="widget about-widget">
                  <div className="logo widget-title">
                    <Link
                      onClick={ClickHandler}
                      to="/home"
                      className="logo-link"
                    >
                      <img src={Logo} alt="Cole Harbour Masjid" />
                      <p className="site-name">Cole Harbour Masjid</p>
                    </Link>
                  </div>
                  <p>
                    A new masjid coming to Cole Harbour, a place of prayer,
                    learning, and community. Join us in building it.
                  </p>
                  {/* TODO: Replace "#" with the real social profile URLs once created */}
                  <ul>
                    <li>
                      <a href="#" aria-label="Facebook">
                        <i className="ti-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" aria-label="Instagram">
                        <i className="ti-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col col-lg-3 offset-lg-1 col-md-6 col-12">
                <div className="widget link-widget">
                  <div className="widget-title">
                    <h3>Quick Links</h3>
                  </div>
                  <ul>
                    <li>
                      <Link onClick={ClickHandler} to="/home">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/about">
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/contact">
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col col-lg-3 offset-lg-1 col-md-6 col-12">
                <div className="widget market-widget wpo-service-link-widget">
                  <div className="widget-title">
                    <h3>Contact</h3>
                  </div>
                  <div className="contact-ft">
                    <ul>
                      <li>
                        <i className="fi ti-location-pin"></i>Cole Harbour, Nova
                        Scotia
                      </li>
                      {/* TODO: Restore phone here when a public masjid phone number is confirmed. */}
                      <li>
                        <i className="fi flaticon-envelope"></i>
                        <a href={`mailto:${MASJID.contactEmail}`}>
                          {MASJID.contactEmail}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wpo-lower-footer">
          <div className="container">
            <div className="row">
              <div className="col col-xs-12">
                <p className="copyright">
                  &copy; {new Date().getFullYear()} Cole Harbour Masjid. All
                  rights reserved
                  <span className="app-version">v{appVersion}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
